module.exports = __webpack_public_path__ + "img/es-pc-s4.59e3fd1b.png";